var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"main-wrapper"},[_c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.text.ravintoloille.mainHeader)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.text.ravintoloille.mainStory)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }